import React, { Component } from 'react';
import { api_url } from "./globalFunction/global_string";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

export class Counter extends Component {
  static displayName = Counter.name;

  constructor(props) {
    super(props);
  }

  handleDownload = async () => {
    const fileName = '教育體系網站弱點掃描服務平台使用說明 v1.25.pdf';
    const fileUrl = `${api_url}/${fileName}`;

    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const fileName = '教育體系網站弱點掃描服務平台使用說明 v1.25.pdf';
    const fileUrl = `${api_url}/${fileName}`;
    return (
      <div id="site-title">
        <h2>使用說明 v1.25 2024.05.27</h2>
        <h5>教育體系網站弱點掃描服務平台 Update</h5>
        <div onClick={this.handleDownload} style={{ fontSize: '24px', cursor: 'pointer' }}>
          <FontAwesomeIcon icon={faFilePdf} /> 教育體系網站弱點掃描服務平台使用說明 v1.25.pdf
        </div>
        <iframe
          src="https://bk.va.nycu.edu.tw:789/%E6%95%99%E8%82%B2%E9%AB%94%E7%B3%BB%E7%B6%B2%E7%AB%99%E5%BC%B1%E9%BB%9E%E6%8E%83%E6%8F%8F%E6%9C%8D%E5%8B%99%E5%B9%B3%E5%8F%B0%E4%BD%BF%E7%94%A8%E8%AA%AA%E6%98%8E%20v1.25.pdf"
          width="100%"
          height="600px"
          style={{ border: 'none' }}>
        </iframe>


      </div>
    );
  }
}  